<template>
    <div class="slds-card__body slds-card__body_inner" >
    <table class="slds-table slds-table_cell-buffer slds-table_bordered" style="table-layout:fixed">
      <thead style="font-size: 100%;">
        <tr class="slds-line-height_reset">
          <th scope="col" style="width:5%">&nbsp;</th>
          <th scope="col" :class="getSortClasses('id')" style="width:7%;font-size:12px">
            <a class="slds-th__action slds-text-link_reset" role="button" tabindex="0" @click="changeSort('id')">
              <div class="slds-grid slds-grid_vertical-align-center slds-has-flexi-truncate">
                <span class="slds-truncate" :title="$t('campaignDesigner.campaignsList.id')">
                  {{ $t('campaignDesigner.campaignsList.id') }}
                </span>
                <span class="slds-icon_container slds-icon-utility-arrowdown">
                  <svg class="slds-icon slds-icon-text-default slds-is-sortable__icon" aria-hidden="true">
                    <use xlink:href="../../assets/symbols.svg#arrowup"></use>
                  </svg>
                </span>
              </div>
            </a>
          </th>
          <th scope="col" :class="getSortClasses('namecomputed')" style="width: 390px;padding: 0;font-size:12px">
            <a class="slds-th__action slds-text-link_reset" role="button" tabindex="0" @click="changeSort('namecomputed')">
              <div class="slds-grid slds-grid_vertical-align-center slds-has-flexi-truncate">
                <span class="slds-truncate" :title="$t('campaignDesigner.campaignsList.campaignName')">
                  {{ $t('campaignDesigner.campaignsList.campaignName') }}
                </span>
                <span class="slds-icon_container slds-icon-utility-arrowdown">
                  <svg class="slds-icon slds-icon-text-default slds-is-sortable__icon" aria-hidden="true">
                    <use xlink:href="../../assets/symbols.svg#arrowup"></use>
                  </svg>
                </span>
              </div>
            </a>
          </th>
          <!-- record type -->
           <th scope="col" :class="getSortClasses('recordType')" style="display: none;padding: 0;font-size:12px">
            <a class="slds-th__action slds-text-link_reset" role="button" tabindex="0" @click="changeSort('recordType')">
              <div class="slds-grid slds-grid_vertical-align-center slds-has-flexi-truncate">
                <span class="slds-truncate" :title="'Record Type'">
                  Record Type
                </span>
                <span class="slds-icon_container slds-icon-utility-arrowdown">
                  <svg class="slds-icon slds-icon-text-default slds-is-sortable__icon" aria-hidden="true">
                    <use xlink:href="../../assets/symbols.svg#arrowup"></use>
                  </svg>
                </span>
              </div>
            </a>
          </th>
          <th scope="col" :class="getSortClasses('type')" style="display: none;padding: 0;font-size:12px">
            <a class="slds-th__action slds-text-link_reset" role="button" tabindex="0" @click="changeSort('type')">
              <div class="slds-grid slds-grid_vertical-align-center slds-has-flexi-truncate">
               <span class="slds-truncate" :title="$t('campaignDesigner.campaignsList.campaignType')">
                {{ $t('campaignDesigner.campaignsList.campaignType') }}
              </span>
              <span class="slds-icon_container slds-icon-utility-arrowdown">
                <svg class="slds-icon slds-icon-text-default slds-is-sortable__icon" aria-hidden="true">
                  <use xlink:href="../../assets/symbols.svg#arrowup"></use>
                </svg>
              </span>
            </div>
            </a>
          </th>
          <th scope="col" :class="getSortClasses('startDate')" style="font-size:12px">
            <a class="slds-th__action slds-text-link_reset" role="button" tabindex="0" @click="changeSort('startDate')">
              <div class="slds-grid slds-grid_vertical-align-center slds-has-flexi-truncate">
                <span class="slds-truncate" :title="$t('campaignDesigner.campaignsList.startDate')">
                  {{ $t('campaignDesigner.campaignsList.startDate') }}
                </span>
                <span class="slds-icon_container slds-icon-utility-arrowdown">
                  <svg class="slds-icon slds-icon-text-default slds-is-sortable__icon" aria-hidden="true">
                    <use xlink:href="../../assets/symbols.svg#arrowup"></use>
                  </svg>
                </span>
              </div>
            </a>
          </th>
          <th scope="col" :class="getSortClasses('endDate')" style="font-size:12px">
            <a class="slds-th__action slds-text-link_reset" role="button" tabindex="0" @click="changeSort('endDate')">
              <div class="slds-grid slds-grid_vertical-align-center slds-has-flexi-truncate">
                <span class="slds-truncate" :title="$t('campaignDesigner.campaignsList.endDate')">
                  {{ $t('campaignDesigner.campaignsList.endDate') }}
                </span>
                 <span class="slds-icon_container slds-icon-utility-arrowdown">
                  <svg class="slds-icon slds-icon-text-default slds-is-sortable__icon" aria-hidden="true">
                    <use xlink:href="../../assets/symbols.svg#arrowup"></use>
                  </svg>
                </span>
              </div>
            </a>
          </th>
          <th scope="col" :class="getSortClasses('createdDate')" style="font-size:12px">
            <a class="slds-th__action slds-text-link_reset" role="button" tabindex="0" @click="changeSort('createdDate')">
              <div class="slds-grid slds-grid_vertical-align-center slds-has-flexi-truncate">
                <span class="slds-truncate" :title="$t('campaignDesigner.campaignsList.createdDate')">
                  {{ $t('campaignDesigner.campaignsList.createdDate') }}
                </span>
                 <span class="slds-icon_container slds-icon-utility-arrowdown">
                  <svg class="slds-icon slds-icon-text-default slds-is-sortable__icon" aria-hidden="true">
                    <use xlink:href="../../assets/symbols.svg#arrowup"></use>
                  </svg>
                </span>
              </div>
            </a>
          </th>
          <th scope="col" :class="getSortClasses('createdByName')" style="font-size:12px">
            <a class="slds-th__action slds-text-link_reset" role="button" tabindex="0" @click="changeSort('createdByName')">
              <div class="slds-grid slds-grid_vertical-align-center slds-has-flexi-truncate">
                <span class="slds-truncate" :title="$t('campaignDesigner.campaignsList.createdBy')">
                  {{$t('campaignDesigner.campaignsList.createdBy')}}
                </span>
                <span class="slds-icon_container slds-icon-utility-arrowdown">
                  <svg class="slds-icon slds-icon-text-default slds-is-sortable__icon" aria-hidden="true">
                    <use xlink:href="../../assets/symbols.svg#arrowup"></use>
                  </svg>
                </span>
              </div>
            </a>
          </th>
          <th scope="col" :class="getSortClasses('status')" style="font-size:12px">
            <a class="slds-th__action slds-text-link_reset" role="button" tabindex="0" @click="changeSort('status')" >
              <div class="slds-grid slds-grid_vertical-align-center slds-has-flexi-truncate" >
                <span class="slds-truncate" :title="$t('campaignDesigner.campaignsList.status.label')" > 
                  {{ $t('campaignDesigner.campaignsList.status.label') }}
                </span>
                <span class="slds-icon_container slds-icon-utility-arrowdown">
                  <svg class="slds-icon slds-icon-text-default slds-is-sortable__icon" aria-hidden="true">
                    <use xlink:href="../../assets/symbols.svg#arrowup"></use>
                  </svg>
                </span>
              </div>
            </a>
          </th>
        </tr>
      </thead>
      <transition-group :name="currentAnimation" tag="tbody">
        <tr class="slds-hint-parent" v-for="campaign in campaignsToShow" :key="`tr_${campaign.id}`">
          <td :data-label="$t('campaignDesigner.campaignsList.campaignName')">
            <div class="slds-truncate">
              <button
                class="slds-button slds-button_icon slds-button_icon-error"
                :title="$t('action.delete')"
                @click="deleteCampaign(campaign.id)"
                v-if="canDeleteCampaign(campaign)">
                <svg class="slds-button__icon" aria-hidden="true">
                  <use xlink:href="../../assets/symbols.svg#delete"></use>
                </svg>
              </button>
            </div>
          </td>
          <td :data-label="$t('campaignDesigner.campaignsList.id')" >
            <div class="slds-truncate" :title="campaign.id" style = "font-size: 12px">
              <router-link :to="`/campaigns/${campaign.id}`" tag="a" >
                {{campaign.id}}
              </router-link>
            </div>
          </td>
          <td :data-label="campaign.namecomputed" style="padding: 0">
            <div class="slds-truncate" :title="campaign.namecomputed" style = "font-size: 12px">
              <router-link :to="`/campaigns/${campaign.id}`" tag="a" >
                {{campaign.namecomputed}}
              </router-link>
            </div>
          </td>
           <td :data-label="campaign.record_type" style="display: none;padding: 0">
            <div class="slds-truncate" :title="campaign.recordType" style="margin-left: 10%;font-size:12px">
                {{campaign.recordType}}
            </div>
          </td>
          <td :data-label="$t('campaignDesigner.campaignsList.type')" style="display: none;padding: 0">
            <div class="slds-truncate" :title="campaign.type" style="margin-left: 10%;font-size:12px">
              {{campaign.type}}
            </div>
          </td>
          <td :data-label="$t('campaignDesigner.campaignsList.startDate')" style="padding: 0">
            <div class="slds-truncate" style="margin-left:8%;font-size: 12px">
              {{campaign.startDate | formatDate($t('general.dateFormat'))}}
            </div>
          </td>
          <td :data-label="$t('campaignDesigner.campaignsList.endDate')" style="padding: 0">
            <div class="slds-truncate" style="margin-left:8%;font-size: 12px">
              {{campaign.endDate | formatDate($t('general.dateFormat'))}}
            </div>
          </td>
          <td :data-label="$t('campaignDesigner.campaignsList.createdDate')" style="padding: 0">
            <div class="slds-truncate" style=" margin-left: 8%;font-size: 12px">
              {{campaign.createdDate | formatDate($t('general.dateFormat'))}}
            </div>
          </td>
          <td :data-label="$t('campaignDesigner.campaignsList.createdBy')" style="padding: 0">
            <div class="slds-truncate" :title="campaign.createdByName" style="font-size: 12px">
              {{campaign.createdByName}}
            </div>
          </td>
          <td :data-label="$t('campaignDesigner.campaignsList.status')" style="padding: 0">
            <div class="slds-truncate" :title="campaign.status" style="margin-left: 19%;font-size: 12px">
              {{$t(`campaignDesigner.campaignsList.status.${campaign.status}`)}}
            </div>
          </td>
        </tr>
      </transition-group>
    </table>
    <div v-if="showPaginationSection" class="pagination-section slds-m-top--medium">
      <div>
        <button class="slds-button slds-button_neutral" @click="goToFirstPage" :disabled="pageNumber === 0"> &lt;&lt; </button>
        <button class="slds-button slds-button_neutral slds-m-right--small" @click="goToPreviousPage" :disabled="pageNumber === 0"> &lt; </button>
        <span> {{ pageNumber + 1 }} / {{pageNumbers + 1}} </span>
        <button class="slds-button slds-button_neutral slds-m-left--small" @click="goToNextPage" :disabled="isNextButtonDisabled"> &gt; </button>
        <button class="slds-button slds-button_neutral" @click="goToLastPage" :disabled="isNextButtonDisabled"> &gt;&gt; </button>
      </div>
    </div>

    <transition name="fade">
      <Modal
        v-if="showDeleteModal"
        @close="hideModal"
        @destructiveButtonClick="doDeleteCampaign"
        :destructiveButtonText="$t('action.delete')"
        :title="$t('campaignDesigner.campaignsList.deleteCampaign')">
        <div class="slds-text-heading_small slds-text-align_center">
          {{$t('campaignDesigner.campaignsList.deleteCampaignConfirm')}}
        </div>
      </Modal>
    </transition>
  </div>
</template>
<script>
import CheckPermission from '../utils/CheckPermission'
import Modal from '../Modal'
import { getErrorMessage } from '../utils/utils'
const PAGE_SIZE = 10

export default {
  mixins: [CheckPermission],
  props: {
    campaigns: Array
  },
  components: {
    Modal
  },
  data () {
    return {
      campaignIdToDelete: -1,
      currentAnimation: 'slide-fade-left-delay',
      pageNumber: 0,
      sortedCampaigns: [],
      sortingOptions: {
        field: '',
        direction: ''
      },
      showDeleteModal: false
    }
  },
  created () {
    this.changeSort('id', 'asc')
  },
  computed: {
    campaignsToShow () {
      if (!this.showPaginationSection) {
        return this.sortedCampaigns
      } else {
        return this.sortedCampaigns.slice(this.startIndex, this.endIndex + 1)
      }
    },
    endIndex () {
      return ((this.pageNumber + 1) * PAGE_SIZE - 1)
    },
    isNextButtonDisabled () {
      return this.campaigns.length <= (this.pageNumber + 1) * PAGE_SIZE
    },
    pageNumbers () {
      return Math.floor(this.campaigns.length / PAGE_SIZE)
    },
    showPaginationSection () {
      return this.campaigns.length > PAGE_SIZE
    },
    startIndex () {
      return this.pageNumber * PAGE_SIZE
    }
  },
  methods: {
    canDeleteCampaign (campaign) {
      return this.checkPermission('MANAGE_CAMPAIGN') && campaign.status === 'Draft' || (campaign.status === 'Active' && campaign.type !== 'DDS')
    },
    changeSort (header, forcedDirection) {
      this.goToFirstPage()
      this.sortedCampaigns = []
      const { field, direction } = this.sortingOptions
      const sortingOptions = {}
      if (field === header) {
        sortingOptions.field = header
        if (!forcedDirection) {
          if (direction === 'asc') {
            sortingOptions.direction = 'desc'
          } else {
            sortingOptions.direction = 'asc'
          }
        } else {
          sortingOptions.direction = forcedDirection
        }
      } else {
        sortingOptions.field = header
        sortingOptions.direction = forcedDirection || 'asc'
      }

      this.sortingOptions = sortingOptions

      const tempCampaigns = _.cloneDeep(this.campaigns)
      this.sortedCampaigns = tempCampaigns.sort((a, b) => {
        if (!a[sortingOptions.field] || a[sortingOptions.field] < b[sortingOptions.field]) return sortingOptions.direction === 'asc' ? -1 : 1
        if (a[sortingOptions.field] === b[sortingOptions.field]) return 0
        if (!b[sortingOptions.field] || a[sortingOptions.field] > b[sortingOptions.field]) return sortingOptions.direction === 'asc' ? 1 : -1
      })
    },
    deleteCampaign (campaignId) {
      this.campaignIdToDelete = campaignId
      this.showDeleteModal = true
    },
    getSortClasses (header) {
      const { field, direction } = this.sortingOptions
      return {
        'slds-is-sorted slds-is-sorted_asc': field === header && direction === 'desc',
        'slds-is-sorted slds-is-sorted_desc': field === header && direction === 'asc'
      }
    },
    hideModal () {
      this.campaignIdToDelete = -1
      this.showDeleteModal = false
    },
    async doDeleteCampaign () {
      try {
        await this.$store.dispatch('campaignDesigner/deleteCampaign', this.campaignIdToDelete)
        this.showToast('success', this.$t('message.delete'), 'text')
        this.$emit('update')
        this.showDeleteModal = false
      } catch (error) {
        console.error(error)
        this.showToast('error', this.$t('general.error'), 'text', getErrorMessage(error))
      }
    },
    goToFirstPage () {
      this.currentAnimation = 'slide-fade-left-delay'
      this.pageNumber = 0
    },
    goToLastPage () {
      this.currentAnimation = 'slide-fade-left-delay'
      this.pageNumber = this.pageNumbers
    },
    goToNextPage () {
      this.currentAnimation = 'slide-fade-left-delay'
      this.pageNumber++
    },
    goToPreviousPage () {
      this.currentAnimation = 'slide-fade-right-delay'
      this.pageNumber--
    }
  },
  watch: {
    campaigns (campaigns) {
      this.changeSort('id', 'asc')
      this.goToFirstPage()
    }
  }
}
</script>
<style scoped lang="scss">
  .pagination-section {
    bottom: 10px;
    display: flex;
    width: 100%;
    align-items: center;

    & > div {
      margin: auto;
    }
  }
</style>
